import { SVGProps } from 'react';

const SvgQuestions = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M9 5.354a4 4 0 1 1 5.824 5.478c-.217.217-.505.395-.693.51l-.046.029a4.338 4.338 0 0 0-.573.399c-.272.236-.512.555-.512 1.23a1 1 0 1 1-2 0c0-1.325.548-2.173 1.2-2.74.298-.259.61-.452.83-.588l.002-.002c.264-.163.345-.22.38-.254a2 2 0 1 0-3.301-2.076 1 1 0 0 1-1.888-.66c.173-.494.44-.943.778-1.326ZM11 18a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgQuestions;
